// Lightweight PL/EN/DE translations - ghostel.app mobile communication site
export const translations = {
  pl: {
    common: {
      login: "Zaloguj",
      logout: "Wyloguj",
      account: "Moje konto",
      register: "Załóż konto",
      download: "Pobierz aplikację",
      learnMore: "Dowiedz się więcej",
      adminPanel: "Panel administratora",
      cancel: "Anuluj",
      save: "Zapisz",
      delete: "Usuń",
      edit: "Edytuj",
      view: "Podgląd",
      search: "Szukaj...",
      actions: "Akcje",
      status: "Status",
      role: "Rola",
      email: "Email",
      password: "Hasło",
      showPassword: "Pokaż hasło",
      hidePassword: "Ukryj hasło",
      backToTop: "Wróć na górę strony",
      name: "Nick",
      username: "Nazwa użytkownika",
      createdAt: "Data utworzenia",
      active: "Aktywny",
      blocked: "Zablokowany",
      pending: "Oczekujący",
    },
    nav: {
      features: "Funkcje",
      why: "Bezpieczeństwo",
      comparison: "Porównanie",
      how: "Jak działa",
      testers: "Testy",
      download: "Pobierz",
      privacy: "Prywatność",
      faq: "FAQ",
      deleteAccount: "Usuń konto",
    },
    hero: {
      titleHighlight: "ghostel.app —",
      title: "komunikator, który dzwoni jak trzeba",
      subtitle:
        "Czat, kontakty, połączenia głosowe i powiadomienia push zaprojektowane tak, żeby rozmowa przychodząca była widoczna nawet na zablokowanym ekranie.",
      cta1: "Otwórz aplikację",
      cta2: "Panel admina",
      tag: "Android · Push · Połączenia głosowe",
    },
    features: {
      title: "Wszystko, czego potrzebuje mobilny komunikator",
      subtitle:
        "ghostel.app łączy szybkie wiadomości, kontakty, statusy, połączenia i kontrolę konta w jednym prostym doświadczeniu.",
      messagesTitle: "Czat i kontakty",
      messagesDesc:
        "Rozmowy 1:1, grupy, zaproszenia po nazwie użytkownika, reakcje i uporządkowana lista kontaktów.",
      groupsTitle: "Statusy i profil",
      groupsDesc:
        "Zdjęcie profilowe, status dostępności, język aplikacji oraz ustawienia prywatności w profilu.",
      voiceTitle: "Połączenia głosowe",
      voiceDesc:
        "Ekran rozmowy w aplikacji, historia połączeń oraz wygodne odbieranie i odrzucanie połączeń.",
      filesTitle: "Powiadomienia połączeń",
      filesDesc:
        "Osobny kanał push dla rozmów, dźwięk, wibracja i pełnoekranowy alert na zablokowanym ekranie.",
      pushTitle: "Eksport danych",
      pushDesc:
        "Użytkownik może pobrać swoje dane z poziomu profilu, bez zgłaszania się do supportu.",
      securityTitle: "Usuwanie konta",
      securityDesc:
        "Konto można trwale usunąć w aplikacji, razem z tokenami push, kontaktami i danymi prywatnymi.",
    },
    why: {
      title: "Dlaczego ghostel.app",
      subtitle: "Dla osób, które chcą szybko napisać, zadzwonić i mieć kontrolę nad swoim kontem.",
      speed: "Szybki kontakt",
      speedDesc: "Najważniejsze akcje są blisko: czat, połączenie, kontakt i status.",
      intuitive: "Czytelne połączenia",
      intuitiveDesc: "Połączenie z aplikacji wygląda jak zdarzenie ghostel.app, nie zwykły telefon.",
      stable: "Push dla rozmów",
      stableDesc: "Osobny typ powiadomienia dla połączeń ułatwia odbiór przy wygaszonym ekranie.",
      secure: "Kontrola danych",
      secureDesc: "Eksport i usunięcie konta są dostępne bezpośrednio w profilu.",
      mobile: "Android first",
      mobileDesc: "Aplikacja jest dopracowywana przede wszystkim pod realne testy na telefonach z Androidem.",
      realtime: "Panel administratora",
      realtimeDesc: "Webowy panel pomaga zarządzać użytkownikami i ustawieniami usługi.",
    },
    how: {
      title: "Jak zacząć",
      subtitle: "Prosty przepływ od konta do pierwszego połączenia.",
      step1: "Tworzysz konto",
      step1Desc: "Rejestrujesz się w aplikacji mobilnej i ustawiasz swój profil.",
      step2: "Dodajesz kontakt",
      step2Desc: "Wyszukujesz osobę po nazwie użytkownika i wysyłasz zaproszenie.",
      step3: "Piszesz lub dzwonisz",
      step3Desc: "Rozmowa działa z poziomu czatu i historii połączeń.",
      step4: "Zarządzasz kontem",
      step4Desc: "Eksportujesz dane, zmieniasz ustawienia albo usuwasz konto, gdy tego potrzebujesz.",
    },
    stats: {
      uptime: "Kanały push",
      messages: "Typy rozmów",
      conversations: "Kontakty i grupy",
      secure: "Kontrola konta",
    },
    testimonials: {
      title: "Zaufały nam zespoły, które nie tolerują kompromisów",
      subtitle: "Od startupów po regulowane branże.",
      t1: "Przeszliśmy z innego komunikatora w jeden weekend. Audyt bezpieczeństwa przeszedł bez uwag.",
      t1Author: "Anna Kowalska",
      t1Role: "CISO, fintech",
      t2: "Disappearing messages + audit log to dokładnie to, czego potrzebował nasz dział prawny.",
      t2Author: "Michał Wiśniewski",
      t2Role: "Head of Engineering",
      t3: "Wreszcie komunikator, którego nasz compliance officer nie blokuje.",
      t3Author: "Julia Nowak",
      t3Role: "VP Operations",
    },
    pricing: {
      title: "Aplikacja mobilna",
      subtitle: "ghostel.app jest przygotowywany do publikacji w Google Play.",
      free: "Android",
      premium: "Testy",
      enterprise: "Kontakt",
      perMonth: "",
      contactSales: "Napisz do nas",
      freeCta: "Otwórz aplikację",
      premiumCta: "Dołącz do testów",
      popular: "W przygotowaniu",
      freeF1: "Czat i kontakty",
      freeF2: "Połączenia głosowe",
      freeF3: "Powiadomienia push dla rozmów",
      freeF4: "Eksport i usuwanie konta",
      premF1: "Wewnętrzne testy Android",
      premF2: "Sprawdzanie powiadomień",
      premF3: "Test wygaszonego ekranu",
      premF4: "Raportowanie błędów",
      premF5: "Aktualizacje przed publikacją",
      entF1: "Wsparcie wdrożenia",
      entF2: "Konfiguracja backendu",
      entF3: "Konfiguracja Firebase",
      entF4: "Pomoc przy publikacji",
      entF5: "Kontakt z administratorem",
    },
    faq: {
      title: "Pytania o aplikację",
      q1: "Czy ghostel.app działa na Androidzie?",
      a1: "Tak. Aplikacja jest przygotowywana pod Androida i testowana na fizycznych urządzeniach.",
      q2: "Czy połączenia pokazują się na zablokowanym ekranie?",
      a2: "Tak, aplikacja używa osobnego powiadomienia dla połączeń przychodzących i może pokazać pełnoekranowy ekran rozmowy.",
      q3: "Czy mogę usunąć konto?",
      a3: "Tak. W profilu aplikacji jest opcja Usuń konto. Publiczna instrukcja jest dostępna na tej stronie.",
      q4: "Czy mogę pobrać swoje dane?",
      a4: "Tak. Profil zawiera eksport danych użytkownika do pliku.",
      q5: "Czy strona jest oficjalnym miejscem do polityki prywatności?",
      a5: "Tak. Strona zawiera politykę prywatności i instrukcję usuwania konta, które można podpiąć w Google Play Console.",
    },
    support: {
      eyebrow: "Wspieraj niezależny rozwój",
      title: "Pomóż nam rozwijać ghostel.app",
      description: "ghostel.app powstaje jako niezależny projekt skupiony na prywatnej komunikacji. Dobrowolne wpłaty BTC pomagają finansować serwery, testy, bezpieczeństwo i kolejne funkcje aplikacji.",
      walletLabel: "Adres portfela Bitcoin",
      copy: "Kopiuj adres",
      copied: "Skopiowano",
      openWallet: "Otwórz portfel",
      note: "Wpłaty są dobrowolne i przeznaczane na rozwój projektu.",
    },
    footer: {
      tagline: "Mobilny komunikator z czatem, połączeniami i powiadomieniami push.",
      about: "O nas",
      contact: "Kontakt",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
      download: "Pobierz aplikację",
      rights: "Wszelkie prawa zastrzeżone.",
    },
    login: {
      title: "Zaloguj się do ghostel.app",
      subtitle: "Jedno konto do strony i aplikacji ghostel.app.",
      submit: "Zaloguj",
      adminHint: "Jeśli jesteś administratorem, po zalogowaniu zobaczysz dostęp do panelu.",
      noAccount: "Nie masz konta?",
      hasAccount: "Masz już konto?",
      backHome: "← Powrót na stronę główną",
      forgotPassword: "Nie pamiętasz hasła?",
    },
    forgotPassword: {
      title: "Zresetuj hasło",
      subtitle: "Wprowadź swój email, a wyślemy Ci kod resetowania hasła.",
      backToLogin: "← Powrót do logowania",
      sendCode: "Wyślij kod",
      codeSent: "Kod resetowania został wysłany!",
      requestFailed: "Nie udało się wysłać kodu",
      networkError: "Błąd połączenia z serwerem",
      resetTitle: "Ustaw nowe hasło",
      resetSubtitle: "Wprowadź 6-cyfrowy kod i nowe hasło.",
      codeLabel: "Kod resetowania",
      codeSentTo: "Kod wysłany na:",
      codeInvalid: "Kod musi mieć 6 cyfr",
      newPassword: "Nowe hasło",
      confirmPassword: "Potwierdź hasło",
      passwordTooShort: "Hasło musi mieć minimum 8 znaków",
      passwordMismatch: "Hasła nie są identyczne",
      resetPassword: "Zmień hasło",
      resetSuccess: "Hasło zostało zmienione! Możesz się zalogować.",
      resetFailed: "Nie udało się zmienić hasła",
      backToEmail: "← Wróć do wprowadzania emaila",
    },
    account: {
      profileLabel: "Konto użytkownika",
      appTitle: "Pełne funkcje są w aplikacji",
      appDesc: "Czaty, kontakty, połączenia i powiadomienia działają w aplikacji mobilnej ghostel.app. Ta strona pomaga zarządzać kontem i dokumentami.",
      openApp: "Otwórz aplikację",
      privacyDesc: "Zasady przetwarzania danych i prywatności.",
      termsDesc: "Warunki korzystania z usługi ghostel.app.",
      deleteDesc: "Instrukcja trwałego usunięcia konta.",
      created: "Konto utworzone",
      footerNote: "Ten panel jest prostym centrum konta. Wiadomości i połączenia pozostają w aplikacji.",
    },
    admin: {
      dashboard: "Dashboard",
      users: "Użytkownicy",
      groups: "Workspaces",
      moderation: "Moderacja",
      notifications: "Powiadomienia",
      support: "Support",
      roles: "Role",
      settings: "Ustawienia",
      reports: "Raporty",
      totalUsers: "Wszyscy użytkownicy",
      activeUsers: "Aktywni użytkownicy",
      onlineUsers: "Online teraz",
      conversations: "Konwersacje",
      totalMessages: "Wiadomości",
      totalGroups: "Workspaces",
      pendingReports: "Zgłoszenia",
      recentActivity: "Ostatnia aktywność",
      newRegistrations: "Nowe rejestracje",
      messagesPerDay: "Wiadomości dziennie",
      userActivity: "Aktywność użytkowników",
      noAccess: "Brak dostępu do panelu administracyjnego",
      sendNotification: "Wyślij powiadomienie",
      title: "Tytuł",
      body: "Treść",
      icon: "Ikona",
      link: "Link docelowy",
      target: "Odbiorca",
      targetAll: "Wszyscy użytkownicy",
      targetGroup: "Wybrany workspace",
      targetUser: "Konkretny użytkownik",
      send: "Wyślij",
      history: "Historia",
      accept: "Akceptuj",
      reject: "Odrzuć",
      blockUser: "Zablokuj",
      exportCsv: "Eksportuj CSV",
      maintenance: "Tryb konserwacji",
      maxFileSize: "Maksymalny rozmiar plików (MB)",
      appName: "Nazwa aplikacji",
      logoUrl: "URL Logo",
      primaryColor: "Kolor podstawowy",
      secondaryColor: "Kolor drugorzędny",
      termsContent: "Treść regulaminu",
      privacyContent: "Treść polityki prywatności",
      generateReport: "Generuj raport",
      profileEdit: "Edytuj profil",
      role: "Rola",
      makeAdmin: "Nadaj rolę admin",
      makeModerator: "Nadaj rolę moderator",
      makeUser: "Nadaj rolę użytkownik",
      block: "Zablokuj",
      unblock: "Odblokuj",
    },
  },
  en: {
    common: {
      login: "Sign in",
      logout: "Sign out",
      account: "My account",
      register: "Sign up",
      download: "Download app",
      learnMore: "Learn more",
      adminPanel: "Admin panel",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      search: "Search...",
      actions: "Actions",
      status: "Status",
      role: "Role",
      email: "Email",
      password: "Password",
      showPassword: "Show password",
      hidePassword: "Hide password",
      backToTop: "Back to top",
      name: "Username",
      username: "Username",
      createdAt: "Created at",
      active: "Active",
      blocked: "Blocked",
      pending: "Pending",
    },
    nav: {
      features: "Features",
      why: "Security",
      comparison: "Comparison",
      how: "How it works",
      testers: "Testing",
      download: "Download",
      privacy: "Privacy",
      faq: "FAQ",
      deleteAccount: "Delete account",
    },
    hero: {
      titleHighlight: "ghostel.app —",
      title: "the messenger that rings clearly",
      subtitle:
        "Chats, contacts, voice calls and push notifications designed so incoming calls are visible even on a locked screen.",
      cta1: "Open app",
      cta2: "Admin panel",
      tag: "Android · Push · Voice calls",
    },
    features: {
      title: "Everything a mobile messenger needs",
      subtitle:
        "ghostel.app brings fast messages, contacts, presence, calls and account controls into one clean mobile experience.",
      messagesTitle: "Chats and contacts",
      messagesDesc:
        "1:1 chats, groups, username invites, reactions and an organized contacts list.",
      groupsTitle: "Status and profile",
      groupsDesc:
        "Profile photo, presence status, app language and privacy settings in one place.",
      voiceTitle: "Voice calls",
      voiceDesc:
        "In-app call screen, call history and simple answer or decline flows.",
      filesTitle: "Call notifications",
      filesDesc:
        "A dedicated call push path with sound, vibration and full-screen incoming call alerts.",
      pushTitle: "Data export",
      pushDesc:
        "Users can export their data directly from the profile screen.",
      securityTitle: "Account deletion",
      securityDesc:
        "Accounts can be deleted in-app together with push tokens, contacts and private account data.",
    },
    why: {
      title: "Why ghostel.app",
      subtitle: "For people who want to message, call and stay in control of their account.",
      speed: "Fast contact",
      speedDesc: "The core actions are close: chat, call, contact and status.",
      intuitive: "Clear calls",
      intuitiveDesc: "An app call looks like a ghostel.app event, not a random phone call.",
      stable: "Call push",
      stableDesc: "A separate notification type helps incoming calls wake the screen.",
      secure: "Data Export",
      secureDesc: "Download your account data from the profile screen.",
      mobile: "Android first",
      mobileDesc: "The app is tuned through real tests on Android phones.",
      realtime: "Admin panel",
      realtimeDesc: "The web panel helps manage users and service settings.",
    },
    how: {
      title: "How to start",
      subtitle: "A simple path from account creation to the first call.",
      step1: "Create an account",
      step1Desc: "Register in the mobile app and set up your profile.",
      step2: "Add a contact",
      step2Desc: "Find a person by username and send an invitation.",
      step3: "Message or call",
      step3Desc: "Start from chat or call history.",
      step4: "Manage your account",
      step4Desc: "Export data, update settings or delete the account when needed.",
    },
    stats: {
      uptime: "Push channels",
      messages: "Conversation types",
      conversations: "Contacts and groups",
      secure: "Account control",
    },
    testimonials: {
      title: "Trusted by teams that don't tolerate compromise",
      subtitle: "From startups to regulated industries.",
      t1: "We migrated from another messenger in one weekend. Security audit passed without notes.",
      t1Author: "Anna Kowalska",
      t1Role: "CISO, fintech",
      t2: "Disappearing messages + audit log is exactly what our legal team needed.",
      t2Author: "Michał Wiśniewski",
      t2Role: "Head of Engineering",
      t3: "Finally a messenger our compliance officer doesn't block.",
      t3Author: "Julia Nowak",
      t3Role: "VP Operations",
    },
    pricing: {
      title: "Mobile app",
      subtitle: "ghostel.app is being prepared for Google Play publication.",
      free: "Android",
      premium: "Testing",
      enterprise: "Contact",
      perMonth: "",
      contactSales: "Contact us",
      freeCta: "Open app",
      premiumCta: "Join testing",
      popular: "In progress",
      freeF1: "Chats and contacts",
      freeF2: "Voice calls",
      freeF3: "Call push notifications",
      freeF4: "Data export and account deletion",
      premF1: "Internal Android testing",
      premF2: "Push notification checks",
      premF3: "Locked-screen call tests",
      premF4: "Bug reports",
      premF5: "Updates before publication",
      entF1: "Deployment support",
      entF2: "Backend configuration",
      entF3: "Firebase configuration",
      entF4: "Publication support",
      entF5: "Administrator contact",
    },
    faq: {
      title: "App FAQ",
      q1: "Does ghostel.app work on Android?",
      a1: "Yes. The app is being prepared for Android and tested on physical devices.",
      q2: "Do calls appear on the locked screen?",
      a2: "Yes. ghostel.app uses a dedicated incoming-call notification path and can show a full-screen call alert.",
      q3: "Can I delete my account?",
      a3: "Yes. The profile screen includes Delete account. A public instruction is available on this site.",
      q4: "Can I export my data?",
      a4: "Yes. The profile screen includes user data export.",
      q5: "Can this site be used for Google Play privacy links?",
      a5: "Yes. It includes privacy policy and account deletion pages that can be linked in Google Play Console.",
    },
    support: {
      eyebrow: "Support independent development",
      title: "Help us build the future of ghostel.app",
      description: "ghostel.app is an independent project focused on private communication. Voluntary BTC contributions help fund servers, testing, security and the next features of the app.",
      walletLabel: "Bitcoin wallet address",
      copy: "Copy address",
      copied: "Copied",
      openWallet: "Open wallet",
      note: "Contributions are voluntary and support the continued development of the project.",
    },
    footer: {
      tagline: "A mobile messenger with chats, calls and push notifications.",
      about: "About",
      contact: "Contact",
      terms: "Terms",
      privacy: "Privacy",
      download: "Download",
      rights: "All rights reserved.",
    },
    login: {
      title: "Sign in to ghostel.app",
      subtitle: "One account for the ghostel.app website and mobile app.",
      submit: "Sign in",
      adminHint: "If you are an administrator, the admin panel will appear after sign-in.",
      noAccount: "No account?",
      hasAccount: "Already have an account?",
      backHome: "← Back to home",
      forgotPassword: "Forgot password?",
    },
    forgotPassword: {
      title: "Reset password",
      subtitle: "Enter your email and we'll send you a password reset code.",
      backToLogin: "← Back to login",
      sendCode: "Send code",
      codeSent: "Password reset code sent!",
      requestFailed: "Failed to send reset code",
      networkError: "Network connection error",
      resetTitle: "Set new password",
      resetSubtitle: "Enter the 6-digit code and your new password.",
      codeLabel: "Reset code",
      codeSentTo: "Code sent to:",
      codeInvalid: "Code must be 6 digits",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      passwordTooShort: "Password must be at least 8 characters",
      passwordMismatch: "Passwords do not match",
      resetPassword: "Reset password",
      resetSuccess: "Password changed! You can now log in.",
      resetFailed: "Failed to reset password",
      backToEmail: "← Back to email entry",
    },
    account: {
      profileLabel: "User account",
      appTitle: "Full features are in the app",
      appDesc: "Chats, contacts, calls and push notifications live in the ghostel.app mobile app. This page keeps account links and documents in one place.",
      openApp: "Open app",
      privacyDesc: "Data processing and privacy rules.",
      termsDesc: "ghostel.app service terms.",
      deleteDesc: "Instructions for permanent account deletion.",
      created: "Account created",
      footerNote: "This is a lightweight account center. Messages and calls stay in the app.",
    },
    admin: {
      dashboard: "Dashboard",
      users: "Users",
      groups: "Workspaces",
      moderation: "Moderation",
      notifications: "Notifications",
      support: "Support",
      roles: "Roles",
      settings: "Settings",
      reports: "Reports",
      totalUsers: "Total users",
      activeUsers: "Active users",
      onlineUsers: "Online now",
      conversations: "Conversations",
      totalMessages: "Messages",
      totalGroups: "Workspaces",
      pendingReports: "Reports",
      recentActivity: "Recent activity",
      newRegistrations: "New registrations",
      messagesPerDay: "Messages per day",
      userActivity: "User activity",
      noAccess: "No access to admin panel",
      sendNotification: "Send notification",
      title: "Title",
      body: "Body",
      icon: "Icon",
      link: "Target link",
      target: "Audience",
      targetAll: "All users",
      targetGroup: "Selected workspace",
      targetUser: "Specific user",
      send: "Send",
      history: "History",
      accept: "Accept",
      reject: "Reject",
      blockUser: "Block",
      exportCsv: "Export CSV",
      maintenance: "Maintenance mode",
      maxFileSize: "Max file size (MB)",
      appName: "App name",
      logoUrl: "Logo URL",
      primaryColor: "Primary color",
      secondaryColor: "Secondary color",
      termsContent: "Terms content",
      privacyContent: "Privacy content",
      generateReport: "Generate report",
      profileEdit: "Edit profile",
      role: "Role",
      makeAdmin: "Make admin",
      makeModerator: "Make moderator",
      makeUser: "Make user",
      block: "Block",
      unblock: "Unblock",
    },
  },
};

translations.de = {
  ...translations.en,
  common: {
    ...translations.en.common,
    login: "Anmelden",
    logout: "Abmelden",
    account: "Mein Konto",
    register: "Registrieren",
    download: "App herunterladen",
    learnMore: "Mehr erfahren",
    adminPanel: "Adminbereich",
    cancel: "Abbrechen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    view: "Anzeigen",
    search: "Suchen...",
    actions: "Aktionen",
    status: "Status",
    role: "Rolle",
    email: "E-Mail",
    password: "Passwort",
    showPassword: "Passwort anzeigen",
    hidePassword: "Passwort ausblenden",
    backToTop: "Nach oben",
    name: "Benutzername",
    username: "Benutzername",
    createdAt: "Erstellt am",
    active: "Aktiv",
    blocked: "Blockiert",
    pending: "Ausstehend",
  },
  nav: {
    features: "Funktionen",
    why: "Sicherheit",
    comparison: "Vergleich",
    how: "So funktioniert es",
    testers: "Tests",
    download: "Download",
    privacy: "Datenschutz",
    faq: "FAQ",
    deleteAccount: "Konto löschen",
  },
  hero: {
    titleHighlight: "ghostel.app –",
    title: "der Messenger, der zuverlässig klingelt",
    subtitle: "Chats, Kontakte, Sprachanrufe und Push-Benachrichtigungen, damit eingehende Anrufe auch auf dem Sperrbildschirm sichtbar sind.",
    cta1: "App öffnen",
    cta2: "Adminbereich",
    tag: "Android · Push · Sprachanrufe",
  },
  features: {
    title: "Alles, was ein mobiler Messenger braucht",
    subtitle: "ghostel.app vereint schnelle Nachrichten, Kontakte, Status, Anrufe und Kontoeinstellungen in einer übersichtlichen App.",
    messagesTitle: "Chats und Kontakte",
    messagesDesc: "Private Chats, Gruppen, Einladungen per Benutzername, Reaktionen und eine geordnete Kontaktliste.",
    groupsTitle: "Status und Profil",
    groupsDesc: "Profilfoto, Verfügbarkeitsstatus, App-Sprache und Datenschutzeinstellungen an einem Ort.",
    voiceTitle: "Sprachanrufe",
    voiceDesc: "Anrufbildschirm, Anrufverlauf und einfaches Annehmen oder Ablehnen.",
    filesTitle: "Anrufbenachrichtigungen",
    filesDesc: "Eigene Push-Benachrichtigungen mit Ton, Vibration und Vollbildanzeige für eingehende Anrufe.",
    pushTitle: "Datenexport",
    pushDesc: "Benutzer können ihre Daten direkt im Profil exportieren.",
    securityTitle: "Konto löschen",
    securityDesc: "Konten können zusammen mit Push-Tokens, Kontakten und privaten Kontodaten in der App gelöscht werden.",
  },
  why: {
    title: "Warum ghostel.app",
    subtitle: "Für Menschen, die schreiben, telefonieren und die Kontrolle über ihr Konto behalten möchten.",
    speed: "Schneller Kontakt",
    speedDesc: "Die wichtigsten Aktionen sind direkt erreichbar: Chat, Anruf, Kontakt und Status.",
    intuitive: "Übersichtliche Anrufe",
    intuitiveDesc: "Ein App-Anruf erscheint eindeutig als ghostel.app-Ereignis.",
    stable: "Anruf-Push",
    stableDesc: "Ein eigener Benachrichtigungstyp hilft, den Bildschirm bei Anrufen zu aktivieren.",
    secure: "Datenexport",
    secureDesc: "Lade deine Kontodaten direkt aus dem Profil herunter.",
    mobile: "Android zuerst",
    mobileDesc: "Die App wird durch echte Tests auf Android-Telefonen optimiert.",
    realtime: "Adminbereich",
    realtimeDesc: "Das Webpanel hilft bei der Verwaltung von Benutzern und Diensteinstellungen.",
  },
  how: {
    title: "Erste Schritte",
    subtitle: "Ein einfacher Weg von der Kontoerstellung bis zum ersten Anruf.",
    step1: "Konto erstellen",
    step1Desc: "Registriere dich in der mobilen App und richte dein Profil ein.",
    step2: "Kontakt hinzufügen",
    step2Desc: "Suche eine Person nach Benutzername und sende eine Einladung.",
    step3: "Schreiben oder anrufen",
    step3Desc: "Starte aus dem Chat oder dem Anrufverlauf.",
    step4: "Konto verwalten",
    step4Desc: "Exportiere Daten, ändere Einstellungen oder lösche dein Konto.",
  },
  stats: {
    uptime: "Push-Kanäle",
    messages: "Unterhaltungstypen",
    conversations: "Kontakte und Gruppen",
    secure: "Kontokontrolle",
  },
  pricing: {
    ...translations.en.pricing,
    title: "Mobile App",
    subtitle: "ghostel.app wird für die Veröffentlichung bei Google Play vorbereitet.",
    free: "Android",
    premium: "Tests",
    enterprise: "Kontakt",
    contactSales: "Kontakt aufnehmen",
    freeCta: "App öffnen",
    premiumCta: "An Tests teilnehmen",
    popular: "In Vorbereitung",
    freeF1: "Chats und Kontakte",
    freeF2: "Sprachanrufe",
    freeF3: "Push-Benachrichtigungen für Anrufe",
    freeF4: "Datenexport und Kontolöschung",
  },
  faq: {
    title: "Fragen zur App",
    q1: "Funktioniert ghostel.app auf Android?",
    a1: "Ja. Die App wird für Android vorbereitet und auf echten Geräten getestet.",
    q2: "Werden Anrufe auf dem Sperrbildschirm angezeigt?",
    a2: "Ja. ghostel.app verwendet eigene Benachrichtigungen für eingehende Anrufe und kann einen Vollbild-Anruf anzeigen.",
    q3: "Kann ich mein Konto löschen?",
    a3: "Ja. Im Profil befindet sich die Option Konto löschen. Eine öffentliche Anleitung ist auf dieser Seite verfügbar.",
    q4: "Kann ich meine Daten herunterladen?",
    a4: "Ja. Das Profil enthält eine Funktion zum Export deiner Benutzerdaten.",
    q5: "Kann diese Seite für Datenschutzlinks bei Google Play verwendet werden?",
    a5: "Ja. Sie enthält eine Datenschutzerklärung und eine Seite zur Kontolöschung.",
  },
  support: {
    eyebrow: "Unabhängige Entwicklung unterstützen",
    title: "Hilf uns, ghostel.app weiterzuentwickeln",
    description: "ghostel.app ist ein unabhängiges Projekt mit Fokus auf private Kommunikation. Freiwillige BTC-Beiträge helfen bei der Finanzierung von Servern, Tests, Sicherheit und neuen Funktionen.",
    walletLabel: "Bitcoin-Wallet-Adresse",
    copy: "Adresse kopieren",
    copied: "Kopiert",
    openWallet: "Wallet öffnen",
    note: "Beiträge sind freiwillig und unterstützen die weitere Entwicklung des Projekts.",
  },
  footer: {
    tagline: "Ein mobiler Messenger mit Chats, Anrufen und Push-Benachrichtigungen.",
    about: "Über uns",
    contact: "Kontakt",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutz",
    download: "Herunterladen",
    rights: "Alle Rechte vorbehalten.",
  },
  login: {
    title: "Bei ghostel.app anmelden",
    subtitle: "Ein Konto für die ghostel.app-Webseite und die mobile App.",
    submit: "Anmelden",
    adminHint: "Administratoren sehen den Adminbereich nach der Anmeldung.",
    noAccount: "Noch kein Konto?",
    hasAccount: "Du hast bereits ein Konto?",
    backHome: "← Zurück zur Startseite",
  },
  account: {
    profileLabel: "Benutzerkonto",
    appTitle: "Alle Funktionen befinden sich in der App",
    appDesc: "Chats, Kontakte, Anrufe und Push-Benachrichtigungen befinden sich in der mobilen ghostel.app-App. Diese Seite bündelt Kontolinks und Dokumente.",
    openApp: "App öffnen",
    privacyDesc: "Regeln zur Datenverarbeitung und zum Datenschutz.",
    termsDesc: "Nutzungsbedingungen des ghostel.app-Dienstes.",
    deleteDesc: "Anleitung zur dauerhaften Kontolöschung.",
    created: "Konto erstellt",
    footerNote: "Dies ist eine einfache Kontozentrale. Nachrichten und Anrufe bleiben in der App.",
  },
  admin: {
    ...translations.en.admin,
    users: "Benutzer",
    moderation: "Moderation",
    notifications: "Benachrichtigungen",
    support: "Support",
    roles: "Rollen",
    settings: "Einstellungen",
    reports: "Berichte",
    totalUsers: "Alle Benutzer",
    activeUsers: "Aktive Benutzer",
    onlineUsers: "Jetzt online",
    conversations: "Unterhaltungen",
    totalMessages: "Nachrichten",
    pendingReports: "Meldungen",
    recentActivity: "Letzte Aktivität",
    newRegistrations: "Neue Registrierungen",
    messagesPerDay: "Nachrichten pro Tag",
    userActivity: "Benutzeraktivität",
    noAccess: "Kein Zugriff auf den Adminbereich",
    sendNotification: "Benachrichtigung senden",
    title: "Titel",
    body: "Inhalt",
    target: "Empfänger",
    targetAll: "Alle Benutzer",
    targetUser: "Bestimmter Benutzer",
    send: "Senden",
    history: "Verlauf",
    accept: "Annehmen",
    reject: "Ablehnen",
    blockUser: "Blockieren",
    maintenance: "Wartungsmodus",
    profileEdit: "Profil bearbeiten",
    role: "Rolle",
    block: "Blockieren",
    unblock: "Blockierung aufheben",
  },
};

translations.es = {
  ...translations.en,
  common: {
    ...translations.en.common,
    login: "Iniciar sesión", logout: "Cerrar sesión", account: "Mi cuenta",
    register: "Crear una cuenta", download: "Descargar la aplicación",
    learnMore: "Más información", adminPanel: "Panel de administración",
    cancel: "Cancelar", save: "Guardar", delete: "Eliminar", edit: "Editar",
    view: "Ver", search: "Buscar...", actions: "Acciones", status: "Estado",
    role: "Rol", email: "Correo electrónico", password: "Contraseña",
    showPassword: "Mostrar contraseña", hidePassword: "Ocultar contraseña",
    backToTop: "Volver arriba", name: "Nombre", username: "Nombre de usuario",
    createdAt: "Fecha de creación", active: "Activo", blocked: "Bloqueado",
    pending: "Pendiente",
  },
  nav: {
    features: "Funciones", why: "Seguridad", comparison: "Comparación",
    how: "Cómo funciona", testers: "Pruebas", download: "Descargar", privacy: "Privacidad",
    faq: "Preguntas frecuentes", deleteAccount: "Eliminar cuenta",
  },
  hero: {
    titleHighlight: "ghostel.app —", title: "el mensajero que siempre suena",
    subtitle: "Chats, contactos, llamadas de voz y notificaciones push diseñados para que las llamadas entrantes sean visibles incluso con la pantalla bloqueada.",
    cta1: "Abrir la aplicación", cta2: "Panel de administración",
    tag: "Android · Push · Llamadas de voz",
  },
  features: {
    title: "Todo lo que necesita un mensajero móvil",
    subtitle: "ghostel.app reúne mensajes rápidos, contactos, presencia, llamadas y control de la cuenta en una experiencia móvil clara.",
    messagesTitle: "Chats y contactos", messagesDesc: "Chats individuales, grupos, invitaciones por nombre de usuario, reacciones y una lista de contactos organizada.",
    groupsTitle: "Estado y perfil", groupsDesc: "Foto de perfil, estado de presencia, idioma y ajustes de privacidad en un solo lugar.",
    voiceTitle: "Llamadas de voz", voiceDesc: "Pantalla de llamada, historial y controles sencillos para responder o rechazar.",
    filesTitle: "Notificaciones de llamadas", filesDesc: "Canal push dedicado con sonido, vibración y alerta de pantalla completa para llamadas entrantes.",
    pushTitle: "Exportación de datos", pushDesc: "Los usuarios pueden exportar sus datos directamente desde el perfil.",
    securityTitle: "Eliminación de la cuenta", securityDesc: "La cuenta puede eliminarse desde la aplicación junto con los tokens push, contactos y datos privados.",
  },
  why: {
    title: "Por qué ghostel.app", subtitle: "Para quienes quieren escribir, llamar y mantener el control de su cuenta.",
    speed: "Contacto rápido", speedDesc: "Las acciones principales están al alcance: chat, llamada, contacto y estado.",
    intuitive: "Llamadas claras", intuitiveDesc: "Una llamada de la aplicación aparece claramente como un evento de ghostel.app.",
    stable: "Push de llamadas", stableDesc: "Un tipo de notificación dedicado ayuda a activar la pantalla con las llamadas entrantes.",
    secure: "Control de datos", secureDesc: "Exporta tus datos o elimina tu cuenta directamente desde el perfil.",
    mobile: "Diseñado para móviles", mobileDesc: "La aplicación se mejora mediante pruebas reales en dispositivos móviles.",
    realtime: "Panel de administración", realtimeDesc: "El panel web permite gestionar usuarios y ajustes del servicio.",
  },
  how: {
    title: "Cómo empezar", subtitle: "Un camino sencillo desde la creación de la cuenta hasta la primera llamada.",
    step1: "Crea una cuenta", step1Desc: "Regístrate en la aplicación móvil y configura tu perfil.",
    step2: "Añade un contacto", step2Desc: "Busca a una persona por su nombre de usuario y envíale una invitación.",
    step3: "Escribe o llama", step3Desc: "Inicia una conversación desde el chat o el historial de llamadas.",
    step4: "Gestiona tu cuenta", step4Desc: "Exporta datos, cambia los ajustes o elimina la cuenta cuando lo necesites.",
  },
  stats: { uptime: "Canales push", messages: "Tipos de conversación", conversations: "Contactos y grupos", secure: "Control de la cuenta" },
  testimonials: {
    title: "La confianza de equipos que no aceptan concesiones", subtitle: "Desde startups hasta sectores regulados.",
    t1: "Migramos desde otro mensajero en un fin de semana. La auditoría de seguridad se superó sin observaciones.", t1Author: "Anna Kowalska", t1Role: "CISO, fintech",
    t2: "Los mensajes temporales y el registro de auditoría eran justo lo que necesitaba nuestro equipo jurídico.", t2Author: "Michał Wiśniewski", t2Role: "Director de Ingeniería",
    t3: "Por fin un mensajero que nuestro responsable de cumplimiento no bloquea.", t3Author: "Julia Nowak", t3Role: "Vicepresidenta de Operaciones",
  },
  pricing: {
    ...translations.en.pricing,
    title: "Aplicación móvil", subtitle: "ghostel.app está disponible para pruebas en Android y se prepara para iOS.",
    free: "Android", premium: "Pruebas", enterprise: "Contacto", contactSales: "Contactar",
    freeCta: "Abrir la aplicación", premiumCta: "Unirse a las pruebas", popular: "En preparación",
    freeF1: "Chats y contactos", freeF2: "Llamadas de voz", freeF3: "Notificaciones push de llamadas", freeF4: "Exportación de datos y eliminación de cuenta",
    premF1: "Pruebas internas", premF2: "Pruebas de notificaciones push", premF3: "Pruebas con la pantalla bloqueada", premF4: "Informes de errores", premF5: "Actualizaciones antes de la publicación",
    entF1: "Ayuda con la implementación", entF2: "Configuración del backend", entF3: "Configuración de Firebase", entF4: "Ayuda con la publicación", entF5: "Contacto con el administrador",
  },
  faq: {
    title: "Preguntas sobre la aplicación",
    q1: "¿Funciona ghostel.app en Android?", a1: "Sí. La aplicación se prueba en dispositivos Android reales.",
    q2: "¿Aparecen las llamadas en la pantalla bloqueada?", a2: "Sí. ghostel.app utiliza notificaciones dedicadas y puede mostrar una llamada entrante a pantalla completa.",
    q3: "¿Puedo eliminar mi cuenta?", a3: "Sí. El perfil incluye la opción para eliminar la cuenta y esta web ofrece instrucciones públicas.",
    q4: "¿Puedo exportar mis datos?", a4: "Sí. Puedes exportar tus datos desde el perfil.",
    q5: "¿Sirve esta web para los enlaces de privacidad de Google Play?", a5: "Sí. Incluye la política de privacidad y las instrucciones para eliminar la cuenta.",
  },
  support: {
    eyebrow: "Apoya el desarrollo independiente", title: "Ayúdanos a desarrollar ghostel.app",
    description: "ghostel.app es un proyecto independiente centrado en la comunicación privada. Las aportaciones voluntarias en BTC financian servidores, pruebas, seguridad y nuevas funciones.",
    walletLabel: "Dirección de la cartera Bitcoin", copy: "Copiar dirección", copied: "Copiada",
    openWallet: "Abrir cartera", note: "Las aportaciones son voluntarias y apoyan el desarrollo continuo del proyecto.",
  },
  footer: { tagline: "Un mensajero móvil con chats, llamadas y notificaciones push.", about: "Acerca de", contact: "Contacto", terms: "Condiciones", privacy: "Privacidad", download: "Descargar", rights: "Todos los derechos reservados." },
  login: {
    title: "Inicia sesión en ghostel.app", subtitle: "Una cuenta para la web y la aplicación móvil de ghostel.app.",
    submit: "Iniciar sesión", adminHint: "Si eres administrador, verás el panel después de iniciar sesión.",
    noAccount: "¿No tienes una cuenta?", hasAccount: "¿Ya tienes una cuenta?", backHome: "← Volver al inicio",
  },
  account: {
    profileLabel: "Cuenta de usuario", appTitle: "Todas las funciones están en la aplicación",
    appDesc: "Los chats, contactos, llamadas y notificaciones están en la aplicación móvil de ghostel.app. Esta página reúne los enlaces de la cuenta y los documentos.",
    openApp: "Abrir la aplicación", privacyDesc: "Reglas de tratamiento de datos y privacidad.",
    termsDesc: "Condiciones del servicio ghostel.app.", deleteDesc: "Instrucciones para eliminar la cuenta de forma permanente.",
    created: "Cuenta creada", footerNote: "Este es un centro de cuenta simplificado. Los mensajes y las llamadas permanecen en la aplicación.",
  },
  admin: {
    ...translations.en.admin,
    dashboard: "Panel", users: "Usuarios", groups: "Grupos", moderation: "Moderación", notifications: "Notificaciones",
    support: "Soporte", roles: "Roles", settings: "Ajustes", reports: "Informes", totalUsers: "Usuarios totales",
    activeUsers: "Usuarios activos", onlineUsers: "En línea ahora", conversations: "Conversaciones", totalMessages: "Mensajes",
    totalGroups: "Grupos", pendingReports: "Informes pendientes", recentActivity: "Actividad reciente", newRegistrations: "Nuevos registros",
    messagesPerDay: "Mensajes por día", userActivity: "Actividad de usuarios", noAccess: "Sin acceso al panel de administración",
    sendNotification: "Enviar notificación", title: "Título", body: "Contenido", target: "Destinatarios", targetAll: "Todos los usuarios",
    targetGroup: "Grupo seleccionado", targetUser: "Usuario específico", send: "Enviar", history: "Historial", accept: "Aceptar",
    reject: "Rechazar", blockUser: "Bloquear", exportCsv: "Exportar CSV", maintenance: "Modo de mantenimiento",
    profileEdit: "Editar perfil", role: "Rol", block: "Bloquear", unblock: "Desbloquear",
  },
};

translations.fr = {
  ...translations.en,
  common: {
    ...translations.en.common,
    login: "Se connecter", logout: "Se déconnecter", account: "Mon compte",
    register: "Créer un compte", download: "Télécharger l’application",
    learnMore: "En savoir plus", adminPanel: "Panneau d’administration",
    cancel: "Annuler", save: "Enregistrer", delete: "Supprimer", edit: "Modifier",
    view: "Afficher", search: "Rechercher...", actions: "Actions", status: "État",
    role: "Rôle", email: "Adresse e-mail", password: "Mot de passe",
    showPassword: "Afficher le mot de passe", hidePassword: "Masquer le mot de passe",
    backToTop: "Retour en haut", name: "Nom", username: "Nom d’utilisateur",
    createdAt: "Date de création", active: "Actif", blocked: "Bloqué", pending: "En attente",
  },
  nav: {
    features: "Fonctionnalités", why: "Sécurité", comparison: "Comparaison",
    how: "Fonctionnement", testers: "Tests", download: "Télécharger", privacy: "Confidentialité",
    faq: "FAQ", deleteAccount: "Supprimer le compte",
  },
  hero: {
    titleHighlight: "ghostel.app —", title: "la messagerie qui sonne clairement",
    subtitle: "Des discussions, des contacts, des appels vocaux et des notifications push conçus pour afficher les appels entrants même lorsque l’écran est verrouillé.",
    cta1: "Ouvrir l’application", cta2: "Panneau d’administration",
    tag: "Android · Push · Appels vocaux",
  },
  features: {
    title: "Tout ce qu’il faut à une messagerie mobile",
    subtitle: "ghostel.app réunit messages rapides, contacts, présence, appels et contrôle du compte dans une expérience mobile claire.",
    messagesTitle: "Discussions et contacts", messagesDesc: "Discussions individuelles, groupes, invitations par nom d’utilisateur, réactions et liste de contacts organisée.",
    groupsTitle: "Statut et profil", groupsDesc: "Photo de profil, statut de présence, langue et paramètres de confidentialité au même endroit.",
    voiceTitle: "Appels vocaux", voiceDesc: "Écran d’appel, historique et commandes simples pour répondre ou refuser.",
    filesTitle: "Notifications d’appel", filesDesc: "Canal push dédié avec son, vibration et alerte plein écran pour les appels entrants.",
    pushTitle: "Export des données", pushDesc: "Les utilisateurs peuvent exporter leurs données directement depuis leur profil.",
    securityTitle: "Suppression du compte", securityDesc: "Le compte peut être supprimé dans l’application avec les jetons push, les contacts et les données privées.",
  },
  why: {
    title: "Pourquoi ghostel.app", subtitle: "Pour celles et ceux qui veulent écrire, appeler et garder le contrôle de leur compte.",
    speed: "Contact rapide", speedDesc: "Les actions principales sont accessibles immédiatement : discussion, appel, contact et statut.",
    intuitive: "Appels clairs", intuitiveDesc: "Un appel de l’application apparaît clairement comme un événement ghostel.app.",
    stable: "Push d’appel", stableDesc: "Un type de notification dédié aide à réveiller l’écran lors d’un appel entrant.",
    secure: "Contrôle des données", secureDesc: "Exportez vos données ou supprimez votre compte directement depuis le profil.",
    mobile: "Conçu pour mobile", mobileDesc: "L’application est améliorée grâce à des tests réels sur des appareils mobiles.",
    realtime: "Panneau d’administration", realtimeDesc: "Le panneau web permet de gérer les utilisateurs et les paramètres du service.",
  },
  how: {
    title: "Comment commencer", subtitle: "Un parcours simple de la création du compte au premier appel.",
    step1: "Créez un compte", step1Desc: "Inscrivez-vous dans l’application mobile et configurez votre profil.",
    step2: "Ajoutez un contact", step2Desc: "Recherchez une personne par son nom d’utilisateur et envoyez une invitation.",
    step3: "Écrivez ou appelez", step3Desc: "Lancez une conversation depuis le chat ou l’historique des appels.",
    step4: "Gérez votre compte", step4Desc: "Exportez vos données, modifiez les paramètres ou supprimez votre compte si nécessaire.",
  },
  stats: { uptime: "Canaux push", messages: "Types de conversation", conversations: "Contacts et groupes", secure: "Contrôle du compte" },
  testimonials: {
    title: "La confiance d’équipes qui refusent les compromis", subtitle: "Des start-up aux secteurs réglementés.",
    t1: "Nous avons migré depuis une autre messagerie en un week-end. L’audit de sécurité a été validé sans remarque.", t1Author: "Anna Kowalska", t1Role: "RSSI, fintech",
    t2: "Les messages temporaires et le journal d’audit correspondaient exactement aux besoins de notre équipe juridique.", t2Author: "Michał Wiśniewski", t2Role: "Directeur de l’ingénierie",
    t3: "Enfin une messagerie que notre responsable conformité ne bloque pas.", t3Author: "Julia Nowak", t3Role: "Vice-présidente des opérations",
  },
  pricing: {
    ...translations.en.pricing,
    title: "Application mobile", subtitle: "ghostel.app est disponible en test sur Android et se prépare pour iOS.",
    free: "Android", premium: "Tests", enterprise: "Contact", contactSales: "Nous contacter",
    freeCta: "Ouvrir l’application", premiumCta: "Participer aux tests", popular: "En préparation",
    freeF1: "Discussions et contacts", freeF2: "Appels vocaux", freeF3: "Notifications push d’appel", freeF4: "Export des données et suppression du compte",
    premF1: "Tests internes", premF2: "Vérification des notifications push", premF3: "Tests sur écran verrouillé", premF4: "Rapports d’erreur", premF5: "Mises à jour avant publication",
    entF1: "Aide au déploiement", entF2: "Configuration du backend", entF3: "Configuration de Firebase", entF4: "Aide à la publication", entF5: "Contact administrateur",
  },
  faq: {
    title: "Questions sur l’application",
    q1: "ghostel.app fonctionne-t-il sur Android ?", a1: "Oui. L’application est testée sur de vrais appareils Android.",
    q2: "Les appels apparaissent-ils sur l’écran verrouillé ?", a2: "Oui. ghostel.app utilise des notifications dédiées et peut afficher un appel entrant en plein écran.",
    q3: "Puis-je supprimer mon compte ?", a3: "Oui. Le profil contient une option de suppression du compte et ce site fournit des instructions publiques.",
    q4: "Puis-je exporter mes données ?", a4: "Oui. Vous pouvez exporter vos données depuis le profil.",
    q5: "Ce site peut-il servir pour les liens de confidentialité Google Play ?", a5: "Oui. Il contient la politique de confidentialité et les instructions de suppression du compte.",
  },
  support: {
    eyebrow: "Soutenez le développement indépendant", title: "Aidez-nous à développer ghostel.app",
    description: "ghostel.app est un projet indépendant centré sur la communication privée. Les contributions volontaires en BTC financent les serveurs, les tests, la sécurité et les nouvelles fonctionnalités.",
    walletLabel: "Adresse du portefeuille Bitcoin", copy: "Copier l’adresse", copied: "Copiée",
    openWallet: "Ouvrir le portefeuille", note: "Les contributions sont volontaires et soutiennent le développement continu du projet.",
  },
  footer: { tagline: "Une messagerie mobile avec discussions, appels et notifications push.", about: "À propos", contact: "Contact", terms: "Conditions", privacy: "Confidentialité", download: "Télécharger", rights: "Tous droits réservés." },
  login: {
    title: "Connectez-vous à ghostel.app", subtitle: "Un seul compte pour le site et l’application mobile ghostel.app.",
    submit: "Se connecter", adminHint: "Si vous êtes administrateur, le panneau s’affichera après la connexion.",
    noAccount: "Vous n’avez pas de compte ?", hasAccount: "Vous avez déjà un compte ?", backHome: "← Retour à l’accueil",
  },
  account: {
    profileLabel: "Compte utilisateur", appTitle: "Toutes les fonctionnalités sont dans l’application",
    appDesc: "Les discussions, contacts, appels et notifications sont disponibles dans l’application mobile ghostel.app. Cette page regroupe les liens du compte et les documents.",
    openApp: "Ouvrir l’application", privacyDesc: "Règles de traitement des données et de confidentialité.",
    termsDesc: "Conditions du service ghostel.app.", deleteDesc: "Instructions pour supprimer définitivement le compte.",
    created: "Compte créé", footerNote: "Ceci est un centre de compte simplifié. Les messages et les appels restent dans l’application.",
  },
  admin: {
    ...translations.en.admin,
    dashboard: "Tableau de bord", users: "Utilisateurs", groups: "Groupes", moderation: "Modération", notifications: "Notifications",
    support: "Assistance", roles: "Rôles", settings: "Paramètres", reports: "Rapports", totalUsers: "Nombre d’utilisateurs",
    activeUsers: "Utilisateurs actifs", onlineUsers: "En ligne", conversations: "Conversations", totalMessages: "Messages",
    totalGroups: "Groupes", pendingReports: "Signalements en attente", recentActivity: "Activité récente", newRegistrations: "Nouvelles inscriptions",
    messagesPerDay: "Messages par jour", userActivity: "Activité des utilisateurs", noAccess: "Accès refusé au panneau d’administration",
    sendNotification: "Envoyer une notification", title: "Titre", body: "Contenu", target: "Destinataires", targetAll: "Tous les utilisateurs",
    targetGroup: "Groupe sélectionné", targetUser: "Utilisateur précis", send: "Envoyer", history: "Historique", accept: "Accepter",
    reject: "Refuser", blockUser: "Bloquer", exportCsv: "Exporter en CSV", maintenance: "Mode maintenance",
    profileEdit: "Modifier le profil", role: "Rôle", block: "Bloquer", unblock: "Débloquer",
  },
};
